import { Config } from '../config';
import { HttpCodes } from '../enums';
import { HttpService } from './http.service';
import { CommandHistoryEntry, DeviceCommand, IssueCommandResponse, SearchCommandsRequest, SearchCommandsResponse } from '../interfaces';

const path = `${Config.API}/messenger-api/v1`;

export abstract class CommandService {
  public static getTemplates = (deviceId?: string): Promise<[]> => {
    const url = deviceId ? `${path}/commands/templates?device_id=${encodeURIComponent(deviceId)}` : `${path}/commands/templates`;
    return HttpService.fetchAuthorized(url).then((res) => res || []);
  };

  // checkDeviceMqttSupport resolves true when the device has a contract version (MQTT supported),
  // false on 409 (no contract version), and rejects on other errors.
  public static checkDeviceMqttSupport = (deviceId: string): Promise<boolean> => {
    const url = `${path}/commands/templates?device_id=${encodeURIComponent(deviceId)}`;
    return HttpService.fetchAuthorized(url, {}, undefined, /* localErrorHandling */ true)
      .then(() => true)
      .catch((res: Response) => {
        if (res?.status === HttpCodes.CONFLICT) {
          return false;
        }
        return Promise.reject(res);
      });
  };

  public static issueCommand = (payload: any): Promise<IssueCommandResponse> => {
    return HttpService.fetchAuthorized(`${path}/commands/issue`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }).then((res) => res || []);
  };

  public static retryGroupCommand = (traceId: string, deviceIds?: string[]): Promise<void> => {
    return HttpService.fetchAuthorized(`${path}/commands/retry-group`, {
      method: 'POST',
      body: JSON.stringify({ trace_id: traceId, ...(deviceIds ? { device_ids: deviceIds } : {}) }),
    });
  };

  public static getDeviceCommands = (deviceId: string): Promise<{ commands: DeviceCommand[] }> => {
    return HttpService.fetchAuthorized(`${path}/devices/${deviceId}/commands`).then((res) => res || { commands: [] });
  };

  public static getCommandHistory = (commandId: string): Promise<CommandHistoryEntry[]> => {
    return HttpService.fetchAuthorized(`${path}/commands/${commandId}/history`).then((res) => res || []);
  };

  public static searchCommands = (filters: SearchCommandsRequest, size: number, page: number): Promise<SearchCommandsResponse> => {
    return HttpService.fetchAuthorized(`${path}/commands/search?size=${size}&page=${page}`, {
      method: 'POST',
      body: JSON.stringify(filters),
    }).then((res) => res || { items: [], total_pages: 0, total_items: 0 });
  };
}
